import React, { useEffect, useState } from 'react';
import { useRefinementList } from 'react-instantsearch';
import './customRefinmentList.css';
import { useTranslation } from 'react-i18next';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
import RightArrow from '../../assets/rightArrow.svg';
import LeftArrow from '../../assets/leftArrow.svg';

interface RefinementItem {
  label: string;
  value: string;
  count: number;
  isRefined: boolean;
}

function CustomRefinementList(props: any) {
  const { t } = useTranslation();
  const { items, refine } = useRefinementList(props);
  const [initialItems, setInitialItems] = useState<RefinementItem[]>([]);
  const [refinementStatus, setRefinementStatus] = useState<Record<string, boolean>>({});

  // Capture initial items and their order only once
  useEffect(() => {
    if (items.length > 0 && initialItems.length === 0) {
      setInitialItems(items);
      const initialRefinementStatus = items.reduce((acc, item) => {
        acc[item.value] = item.isRefined;
        return acc;
      }, {} as Record<string, boolean>);
      setRefinementStatus(initialRefinementStatus);
    }
  }, [items, initialItems.length]);

  // Update refinement status based on items updates
  useEffect(() => {
    const newRefinementStatus = items.reduce((acc, item) => {
      acc[item.value] = item.isRefined;
      return acc;
    }, {} as Record<string, boolean>);
    setRefinementStatus(newRefinementStatus);
  }, [items]);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>, value: string) => {
    event.preventDefault();
    refine(value);
  };

  // Custom Arrow components
  function NextArrow(props: any) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <img className="arrows-custom-style" src={RightArrow} alt="Next" />
      </div>
    );
  }

  function PrevArrow(props: any) {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <img className="arrows-custom-style" src={LeftArrow} alt="Prev" />
      </div>
    );
  }

  // Settings for the slick carousel
  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    infinite: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  return (
    <>
      <div className='filter-container'>
        <div className='filter-title'>{t("filter")}</div>
        <div className='filter-line' />
        <div className="slider-container">
          <Slider {...settings}>
            {initialItems.map((item, index) => (
              <div key={index}>
                <div
                  className='filter-item'
                  onClick={(event) => handleClick(event, item.value)}
                  style={{
                    fontWeight: refinementStatus[item.value] ? 'bold' : 'normal',
                    background: refinementStatus[item.value] ? '#e5f3ff' : '#fff',
                    border: refinementStatus[item.value] ? '1px solid #008cff' : '1px solid var(--neutrals-100, #d5d8df)',
                    borderRadius: '16px',
                    color: refinementStatus[item.value] ? '#008cff' : 'black',
                  }}
                >
                  {item.label}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
}

export default CustomRefinementList;
